import Feature11_2 from './Feature11_2'
export default Feature11_2
